/**
 * Google Analytics utility functions
 */

// Initialize Google Analytics
export const initializeGA = (measurementId: string): void => {
  // Check if Google Analytics is already loaded
  if ((window as any).ga) return;

  // Create script element
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  
  // Append script to head
  document.head.appendChild(script);
  
  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  function gtag(...args: any[]) {
    window.dataLayer.push(arguments);
  }
  
  (window as any).gtag = gtag;
  gtag('js', new Date());
  gtag('config', measurementId, {
    anonymize_ip: true,
    cookie_flags: 'SameSite=None;Secure'
  });
};

// Track page view
export const trackPageView = (path: string, title?: string): void => {
  if (!(window as any).gtag) return;
  
  (window as any).gtag('event', 'page_view', {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href
  });
};

// Track event
export const trackEvent = (
  category: string,
  action: string,
  label?: string,
  value?: number
): void => {
  if (!(window as any).gtag) return;
  
  (window as any).gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value
  });
};

// Track user sign up
export const trackSignUp = (method: string): void => {
  if (!(window as any).gtag) return;
  
  (window as any).gtag('event', 'sign_up', {
    method: method
  });
};

// Track user login
export const trackLogin = (method: string): void => {
  if (!(window as any).gtag) return;
  
  (window as any).gtag('event', 'login', {
    method: method
  });
};

// Set user properties
export const setUserProperties = (properties: Record<string, any>): void => {
  if (!(window as any).gtag) return;
  
  (window as any).gtag('set', 'user_properties', properties);
};

// Opt out of Google Analytics
export const optOutGA = (): void => {
  (window as any)['ga-disable-' + import.meta.env.VITE_GA_MEASUREMENT_ID] = true;
  
  // Remove any existing cookies
  document.cookie = '_ga=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  document.cookie = '_gid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  document.cookie = '_gat=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  
  // Save preference in local storage
  localStorage.setItem('ga-opt-out', 'true');
};

// Check if user has opted out
export const hasOptedOutGA = (): boolean => {
  return localStorage.getItem('ga-opt-out') === 'true';
};